import { render, staticRenderFns } from "./ProductoDetalle.vue?vue&type=template&id=5e7ac05a&scoped=true"
import script from "./ProductoDetalle.vue?vue&type=script&lang=js"
export * from "./ProductoDetalle.vue?vue&type=script&lang=js"
import style0 from "./ProductoDetalle.vue?vue&type=style&index=0&id=5e7ac05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ac05a",
  null
  
)

export default component.exports